@if (overlayOpen()) {
	<ui-overlay
		[header]="'cookie.headline' | translate"
		[showCloseButton]="false"
		data-cy="c-cookie-overlay"
	>
		<cookie-description></cookie-description>
		<div class="pt-6 flex flex-col gap-2">
			<ui-button
				[text]="'cookie.accept_all' | translate"
				(buttonClicked)="accept()"
				[fullWidth]="true"
				type="dark"
				data-cy="c-cookie-consent-accept"
			></ui-button>
		</div>
	</ui-overlay>
}
